import { render, staticRenderFns } from "./NewCommonFlow.vue?vue&type=template&id=4a7eaffe&scoped=true"
import script from "./NewCommonFlow.vue?vue&type=script&lang=js"
export * from "./NewCommonFlow.vue?vue&type=script&lang=js"
import style0 from "./NewCommonFlow.vue?vue&type=style&index=0&id=4a7eaffe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7eaffe",
  null
  
)

export default component.exports